<template>
  <v-card
    elevation="0"
    class="vue-json-query-builder bg-transparent"
    :style="{ 'pointer-events': false ? 'none' : 'all' }"
  >
    <b-card-body class="p-2 bg-transparent" v-if="isVisible">
      <ActionGroup
        :current-query="query"
        :options="options"
        :userId="userId"
        ref="actionGroup"
      />
    </b-card-body>
  </v-card>
</template>

<script>
import ActionGroup from "@/own/components/orderManagement/promotions/SKUQuantityBuilder/ActionGroup.vue";
export default {
  name: "ActionBuilder",
  components: {
    ActionGroup,
  },
  props: {
    query: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },

    userId: {
      required: false,
    },
  },
  data: function () {
    return {
      isVisible: true,
    };
  },
  methods: {
    addDefault() {
      this.$refs.actionGroup.addRule();
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-json-query-builder {
  font-size: 12px;
  user-select: none;
  * {
    font-size: 15px !important;
  }
  .vue-json-query-builder-header {
    cursor: pointer;
  }
}
</style>
